module.exports = __webpack_public_path__ + "static/media/error.34f71837.svg";